const API_BASE = (import.meta.env.VITE_API_BASE_URL as string | undefined) ?? '';

export async function subscribeSubprocessors(email: string, privacyConsent: boolean): Promise<void> {
  const res = await fetch(`${API_BASE}/api/v1/subprocessors/subscriptions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, privacyConsent }),
  });
  if (res.status === 202) return;
  if (res.status === 400) {
    const data = await res.json().catch(() => ({}));
    throw new Error((data as { error?: string }).error ?? 'invalid_input');
  }
  if (res.status === 429) {
    throw new Error('rate_limited');
  }
  throw new Error(`subscribe_failed_${res.status}`);
}

export async function unsubscribeSubprocessors(email: string): Promise<void> {
  const res = await fetch(`${API_BASE}/api/v1/subprocessors/subscriptions`, {
    method: 'DELETE',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  if (!res.ok) throw new Error(`unsubscribe_failed_${res.status}`);
}
